import { AppointmentInfo, Slot } from '../../../models/Orders';

export const saveModifyAppointmentInfo = (
    orderDescription: string,
    appointmentInfo: AppointmentInfo,
    slots: Slot[],
) => {
    const storage = {
        orderDescription: orderDescription,
        appointmentInfo: appointmentInfo,
        slots: slots,
    };
    localStorage.setItem('modify-appointment-info', JSON.stringify(storage));
};

export const saveModifyAppointmentSelectedSlot = (selectedSlot: Slot) => {
    const storage = retrieveModifyAppointmentInfo();
    storage.selectedSlot = selectedSlot;
    localStorage.setItem('modify-appointment-info', JSON.stringify(storage));
};

export const retrieveModifyAppointmentInfo = (): {
    orderDescription: string;
    appointmentInfo: AppointmentInfo;
    slots: Slot[];
    selectedSlot: Slot;
} => {
    const storage = localStorage.getItem('modify-appointment-info') || '';
    return JSON.parse(storage);
};
